// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"65f7a481","13":"65f7a481","419":"65f7a481","502":"65f7a481","801":"65f7a481","850":"65f7a481"}[chunkId] + ".chunk.css";
};